import { createFileRoute, redirect } from "@tanstack/react-router";

// Arkivet lever nu nederst på /artikler som uge-grupperet oversigt.
// Denne rute bevares alene for gamle links og sender videre.
export const Route = createFileRoute("/arkiv")({
  beforeLoad: () => {
    throw redirect({ to: "/artikler", replace: true });
  },
});
